import { render } from "./Desuscribirse.vue?vue&type=template&id=b38c6040&scoped=true"
import script from "./Desuscribirse.vue?vue&type=script&lang=js"
export * from "./Desuscribirse.vue?vue&type=script&lang=js"

import "./Desuscribirse.vue?vue&type=style&index=0&id=b38c6040&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b38c6040"]])

export default __exports__